import React from "react";

import { connect } from "react-redux";
import {
    reset,
    downloadFile,
    remove,
    list,
    isLoading,
    isLoaded,
    getMeta,
    getList,
    getError,
    isSecondaryLoading,
} from "../../../../redux/actions/manager/purchaseOrder/list";

import {
    CACHE_VENDOR,
    loadCache,
    isCacheLoading,
    isCacheLoaded,
    getVendorsForSelect,
} from "../../../../redux/actions/cache/interface";

import { isAdmin } from "../../../../redux/actions/config/session";

import {
    encodeQueryToURL,
    decodeQueryFromURL,
    onTableChangeUpdateUrl,
    onFilterChangeUpdateUrl,
} from "../../../../core/utils/list";

import { LAYOUT_FINANCE_PURCHASE_ORDER_FORM } from "../../navigation";
import FullList from "../../../../core/components/listPattern/list";

import { basicColumns } from "./fields";
import Filters from "./filters";

/**
 * Container:
 *
 *   Se encarga de la conexion entre Redux y el Componente  que presenta los datos
 *
 * De paso en algunos caso, excepto formularios se maneja el Loading y el título.
 *
 * OBS: En formularios es mejor que el 'loading' lo maneje el formulario dado que Formik
 *    si se redibuja pierde los datos, entonces hay que tener cuidado con eso.
 */
class Container extends React.Component {
    constructor(props) {
        super(props);
        const defaultValues = { active: 1 };
        const defaultHidden = [];
        defaultHidden["u.active"] = 1;
        this.state = { defaultValues, resize: [], hidden: defaultHidden };
    }

    componentDidMount() {
        const query = decodeQueryFromURL(this.props.history, this.state.defaultValues);

        const queryParams = { query };

        this.props.loadCache();
        this.props.list(query);
    }

    componentDidUpdate(prevProps) {
        const { history } = this.props;

        if (history.location.search != prevProps.location.search) {
            const query = decodeQueryFromURL(history, this.state.defaultValues);

            this.props.list(query);
        }
    }

    componentWillUnmount() {
        this.props.reset();
    }

    _goBack = () => {
        this.props.history.goBack();
    };

    _setColumns = (cols) => {
        this.setState({ columns: cols });
    };

    _onResize = (col, index) => (e, { size }) => {
        const nextResize = [...this.state.resize];
        nextResize[col] = size.width;
        this.setState({ resize: nextResize });
    };

    _onToggleVisible = (col) => {
        const nextHidden = this.state.hidden;
        const value = nextHidden[col] ? nextHidden[col] : 0;
        nextHidden[col] = value == 0 ? 1 : 0;
        this.setState({ hidden: nextHidden });
    };

    _onFilterChangeUpdateUrl = (form) => onFilterChangeUpdateUrl(this.props.history, form);
    _onTableChangeUpdateUrl = (pagination, filters, sorter) =>
        onTableChangeUpdateUrl(this.props.history, pagination, filters, sorter);

    render() {
        const parameters = decodeQueryFromURL(this.props.history, this.state.defaultValues);
        const columns = basicColumns({
            ...this.props,
            filters: parameters,
            resize: this.state.resize,
            hidden: this.state.hidden,
        });
        return (
            <>
                <FullList
                    {...this.props}
                    titulo={"PURCHASE ORDERS"}
                    subtitulo="Vendor"
                    onPressBack={this._goBack}
                    onPressNew={LAYOUT_FINANCE_PURCHASE_ORDER_FORM}
                    onSearchByText={(text) => this._onFilterChangeUpdateUrl({ text })}
                    resize
                    columns={columns}
                    onResize={this._onResize}
                    onToggleVisible={this._onToggleVisible}
                    setColumns={this._setColumns}
                    filters={parameters}
                    onUpdateFilters={this._onFilterChangeUpdateUrl}
                    handleTableChange={this._onTableChangeUpdateUrl}
                >
                    <Filters filters={parameters} onUpdateFilters={this._onFilterChangeUpdateUrl} {...this.props} />
                </FullList>
            </>
        );
    }
}

const cacheList = [CACHE_VENDOR];

function MapStateToProps(state) {
    return {
        meta: getMeta(state),
        data: getList(state),
        loading: isLoading(state) || isCacheLoading(state, cacheList),
        actionLoading: isSecondaryLoading(state),
        error: getError(state),

        isAdmin: isAdmin(state),

        loaded: isLoaded(state) && isCacheLoaded(state, cacheList),
        vendors: getVendorsForSelect(state),
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        loadCache: () => loadCache(cacheList)(dispatch),
        list: (query) => dispatch(list(query)),
        reset: () => dispatch(reset()),
        remove: (id) => dispatch(remove(id)),
        downloadFile: (id, name) => dispatch(downloadFile(id, name)),
    };
};

export default connect(MapStateToProps, mapDispatchToProps)(Container);
